import { useShowContextRequired } from 'ui-builder';
import { WebhookSubscription } from 'nekst-api';

export default function WebhookEnabledField() {
  const { data } = useShowContextRequired<WebhookSubscription>();

  if (data.isEnabled) {
    return 'Enabled';
  } else {
    return 'Disabled';
  }
}
